import {
  BtcLogo,
  DotLogo,
  EthLogo,
  FlipLogo,
  SolLogo,
  UsdcLogo,
  UsdtLogo,
  WbtcLogo,
  TronLogo,
  BnbLogo,
  CbbtcLogo,
} from '@/shared/assets/token-logos';
import { type SupportedTokenSymbol, type Token } from '.';

export const tokenLogoMap: Record<
  Token['symbol'],
  (props?: React.SVGProps<SVGSVGElement>) => React.JSX.Element
> = {
  BTC: BtcLogo,
  SOL: SolLogo,
  tBTC: BtcLogo,
  tSOL: SolLogo,
  bSOL: SolLogo,
  ETH: EthLogo,
  sETH: EthLogo,
  bETH: EthLogo,
  FLIP: FlipLogo,
  sFLIP: FlipLogo,
  bFLIP: FlipLogo,
  USDC: UsdcLogo,
  sUSDC: UsdcLogo,
  stUSDC: UsdcLogo,
  sbUSDC: UsdcLogo,
  stUSDT: UsdtLogo,
  sbUSDT: UsdtLogo,
  bUSDC: UsdcLogo,
  USDT: UsdtLogo,
  sUSDT: UsdtLogo,
  bUSDT: UsdtLogo,
  DOT: DotLogo,
  pDOT: DotLogo,
  hDOT: DotLogo,
  hUSDT: UsdtLogo,
  hUSDC: UsdcLogo,
  WBTC: WbtcLogo,
  sWBTC: WbtcLogo,
  bWBTC: WbtcLogo,
  TRX: TronLogo,
  nTRX: TronLogo,
  nTrxUSDT: UsdtLogo,
  bTRX: TronLogo,
  bTrxUSDT: UsdtLogo,
  BNB: BnbLogo,
  tBNB: BnbLogo,
  bBNB: BnbLogo,
  tBscUSDT: UsdtLogo,
  bBscUSDT: UsdtLogo,
  cbBTC: CbbtcLogo,
  scbBTC: CbbtcLogo,
  bcbBTC: CbbtcLogo,
} satisfies Record<
  SupportedTokenSymbol,
  (props?: React.SVGProps<SVGSVGElement>) => React.JSX.Element
>;
